//export const baseUrl = "http://10.40.55.28:6005"
export const baseUrl = "https://apiminiappzalocat.caobang.gov.vn/cacb"
//export const baseUrl = "https://watersupply.mobifone5.vn/cacb"
export default {
    baseUrl
}
